import { TabPanel, TabView, TabViewTabChangeEvent } from 'primereact/tabview';
import { useSearchParams } from 'react-router-dom';
import { ConditionTemplatesTab } from './ConditionTemplatesTab';
import { Container, PageTitle, ScaledContent } from './ManageTemplates.StyledComponents';
import { NmiTemplatesTab } from './NmiTemplatesTab';

const TAB_PARAM_NMI = 'nmi';
const TAB_PARAM_CONDITION = 'condition';

export const ManageTemplates = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const activeIndex = searchParams.get('tab') === TAB_PARAM_NMI ? 1 : 0;

    const handleTabChange = (event: TabViewTabChangeEvent) => {
        const next = new URLSearchParams(searchParams);
        next.set('tab', event.index === 1 ? TAB_PARAM_NMI : TAB_PARAM_CONDITION);
        setSearchParams(next);
    };

    return (
        <Container data-testid="manage-templates-page">
            <PageTitle>Manage Templates</PageTitle>
            <ScaledContent>
                <TabView activeIndex={activeIndex} onTabChange={handleTabChange}>
                    <TabPanel header="Task/Condition Templates">
                        <ConditionTemplatesTab />
                    </TabPanel>
                    <TabPanel header="NMI Templates">
                        <NmiTemplatesTab />
                    </TabPanel>
                </TabView>
            </ScaledContent>
        </Container>
    );
};
